module.exports = __webpack_public_path__ + "static/media/1.16f3c687.svg";